<template>
  <div>
    <v-container>
      <v-row>
        <v-expansion-panels
          multiple
          v-model="panel"
          v-if="client == '128' || client == 'LAMCOR'"
        >
          <v-expansion-panel>
            <v-expansion-panel-header
              >Payroll Location</v-expansion-panel-header
            >
            <v-expansion-panel-content>
              <template>
                <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
                  <pay-loc-selection
                    :show-dense="false"
                    :headers="payLocHeaders"
                    :show-select="true"
                    v-model="payLoc"
                    :by-user="true"
                  ></pay-loc-selection>
                </v-col>
              </template>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>Employee List</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
                <employee-selection
                  :show-dense="false"
                  :show-select="true"
                  v-model="employees"
                  :pay-loc="payLoc"
                ></employee-selection>
              </v-col>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <template v-else>
          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
            <emp-lookup
              :class-padding="classPadding"
              v-model="selectedEmp"
              label="Employee Code"
              title="Employee"
              :code-value="true"
              :off-remarks="true"
            ></emp-lookup>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="8" :class="classPadding">
            <v-text-field
              label="Name"
              :value="selectedEmp.desc"
              :class="classPadding"
            ></v-text-field>
          </v-col>
        </template>
      </v-row>
      <v-row
        v-if="
          client == 'IBC' &&
            (format == 'EmploymentContract_3.rpt' || format == 'Fixed_Term')
        "
      >
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-text-field
            label="ID"
            v-model="id1"
            :class="classPadding"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row :class="client == '128' || client == 'LAMCOR' ? 'mt-4' : ''">
        <v-col
          cols="12"
          xs="12"
          sm="6"
          md="4"
          :class="classPadding"
          v-if="client == 'IBSI'"
        >
          <v-text-field
            label="Basic Salary"
            :class="classPadding"
            v-model="basicSalary"
          ></v-text-field>
        </v-col>
        <v-col
          cols="12"
          xs="12"
          sm="6"
          md="4"
          :class="classPadding"
          v-if="client == 'IBSI' || client == 'IBC'"
        >
          <emp-lookup
            :class-padding="classPadding"
            v-model="signatory"
            label="Signatory"
            title="Employee"
            :code-value="true"
            :off-remarks="true"
          ></emp-lookup>
        </v-col>
        <v-col
          cols="12"
          xs="12"
          sm="6"
          md="4"
          :class="classPadding"
          v-if="client == 'IBSI'"
        >
          <v-text-field
            label="Signatory Designation"
            v-model="designation"
            :class="classPadding"
          ></v-text-field>
        </v-col>
        <v-col
          cols="12"
          xs="12"
          sm="6"
          md="4"
          :class="classPadding"
          v-if="
            client == 'IBC' &&
              (format == 'EmploymentContract_3.rpt' || format == 'Fixed_Term')
          "
        >
          <v-text-field
            :class="classPadding"
            label="ID"
            v-model="id2"
          ></v-text-field>
        </v-col>

        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-select
            label="Contract Format 2"
            :class="classPadding"
            :items="formats"
            item-text="description"
            item-value="value"
            v-model="format"
          ></v-select>
        </v-col>

        <v-col
          cols="12"
          xs="12"
          sm="6"
          md="4"
          :class="classPadding"
          v-if="
            client == 'IBC' &&
              (format == 'Project_Base' ||
                format == 'EmploymentContract_3.rpt' ||
                format == 'Fixed_Term' ||
                format == 'Casual')
          "
        >
          <v-text-field
            label="From"
            v-model="from"
            :class="classPadding"
            type="time"
          ></v-text-field>
          <!-- <work-shift-lookup
            :class-padding="classPadding"
            v-model="workshift"
            label="Workshift"
            title="Workshift"
          ></work-shift-lookup> -->
        </v-col>
        <v-col
          cols="12"
          xs="12"
          sm="6"
          md="4"
          :class="classPadding"
          v-if="
            client == 'IBC' &&
              (format == 'Project_Base' ||
                format == 'EmploymentContract_3.rpt' ||
                format == 'Fixed_Term' ||
                format == 'Casual')
          "
        >
          <v-text-field
            label="To"
            v-model="to"
            :class="classPadding"
            type="time"
          ></v-text-field>
          <!-- <work-shift-lookup
            :class-padding="classPadding"
            v-model="workshift"
            label="Workshift"
            title="Workshift"
          ></work-shift-lookup> -->
        </v-col>
        <v-col
          cols="12"
          xs="12"
          sm="6"
          md="4"
          :class="classPadding"
          v-if="
            client == 'IBC' &&
              (format == 'Project_Base' ||
                format == 'EmploymentContract_3.rpt' ||
                format == 'Fixed_Term' ||
                format == 'Casual')
          "
        >
          <v-text-field
            label="Break Duration (hh:mm)"
            v-model="breakSched"
            :class="classPadding"
            v-mask="'##:##'"
          ></v-text-field>
          <!-- <work-shift-lookup
            :class-padding="classPadding"
            v-model="workshift"
            label="Workshift"
            title="Workshift"
          ></work-shift-lookup> -->
        </v-col>
        <v-col
          cols="12"
          xs="12"
          sm="6"
          md="4"
          :class="classPadding"
          v-if="
            client == 'IBC' &&
              (format == 'EmploymentContract_1.rpt' ||
                format == 'EmploymentContract_2.rpt')
          "
        >
          <custom-datepicker
            :class-padding="classPadding"
            label="Date"
            v-model="dateFrom"
          ></custom-datepicker>
        </v-col>

        <v-col
          cols="12"
          xs="12"
          sm="6"
          md="4"
          :class="classPadding"
          v-if="client == 'FEDERAL' && format == 'EmploymentContract_2.rpt'"
        >
          <v-select
            :items="letterContents"
            item-text="messageCode"
            :class="classPadding"
            item-value="messageCode"
            v-model="messageCode"
            label="Letter Content"
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-expansion-panels
          multiple
          v-model="panel"
          v-if="
            client == 'IBC' &&
              (format == 'Fixed_Term' ||
                format == 'Casual' ||
                format == 'Project_Base' ||
                format == 'EmploymentContract_3.rpt')
          "
        >
          <v-expansion-panel>
            <v-expansion-panel-header>Witness</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
                <employee-selection
                  :show-dense="false"
                  :show-select="true"
                  v-model="employees"
                  :pay-loc="payLoc"
                ></employee-selection>
              </v-col>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>
      <v-row v-if="client == 'CCF' && format == 'EmploymentContract_1.rpt'">
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-text-field
            label="Time Start"
            v-model="breakDuration"
            :class="classPadding"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-text-field
            label="No. of working Days"
            v-model="breakDay"
            :class="classPadding"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row
        v-if="
          client == 'CCF' &&
            (format == 'EmploymentContract_3.rpt' ||
              format == 'EmploymentContract_1.rpt')
        "
      >
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <emp-lookup
            :class-padding="classPadding"
            v-model="supervisor"
            label="Immediate Supervisor"
            title="Employee"
            :code-value="true"
            :off-remarks="true"
          ></emp-lookup>
        </v-col>
      </v-row>
      <span
        v-if="
          client == 'CCF' &&
            (format == 'Cons_Agreement' || format == 'EmploymentContract_1.rpt')
        "
        >Cutoff</span
      >
      <v-row
        v-if="
          client == 'CCF' &&
            (format == 'Cons_Agreement' || format == 'EmploymentContract_1.rpt')
        "
      >
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-checkbox
            label="15th"
            v-model="cutoff"
            :class="classPadding"
            value="15"
          ></v-checkbox>
          <!-- <v-select
            :items="letterContents"
            item-text="messageCode"
            :class="classPadding"
            item-value="messageCode"
            v-model="messageCode"
            label="Letter Content"
          ></v-select> -->
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-checkbox
            label="30th"
            value="30"
            v-model="cutoff"
            :class="classPadding"
          ></v-checkbox>
        </v-col>

        <!-- <v-col
          v-if="format == 'EmploymentContract_3.rpt'"
          cols="12"
          xs="12"
          sm="6"
          md="4"
          :class="classPadding"
        >
          <v-checkbox
            label="20th"
            value="20"
            v-model="cutoff"
            :class="classPadding"
          ></v-checkbox>
        </v-col> -->

        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-text-field
            label="Year (Contract Signed)"
            v-model="yearContractSigned"
            :class="classPadding"
            min="1900"
            max="2099"
            step="1"
            type="number"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row v-if="client == 'CCF' && format == 'EmploymentContract_3.rpt'">
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <v-text-field
            label="Year (Contract Signed)"
            v-model="yearContractSigned"
            :class="classPadding"
            min="1900"
            max="2099"
            step="1"
            type="number"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col xs="12" sm="12" md="12" :class="classPadding">
          <v-btn
            outlined
            @click.stop="exportReport"
            :loading="loading"
            :class="classPadding"
            >Export</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { isNullOrUndefined } from "../../../validation/validation";
import { mask } from "vue-the-mask";
const EmpLookup = () =>
  import("../../maintenance/employee-masterfile/personal-info/Lookup");

const EmployeeSelection = () =>
  import("../../maintenance/employee-masterfile/personal-info/NewSelection");

const PayLocSelection = () =>
  import("../../setup/general/payroll-location/NewSelection");

const WorkShiftLookup = () => import("../../others/WorkshiftLookup.vue");

const CustomDatepicker = () => import("../../../components/CustomDatepicker");

const API_ENDPOINT = "/api/reports";
const API_ENDPOINT_OTHERS = "/api/other";
const API_ENDPOINT_LETTER = "/api/letterContent";
export default {
  directives: {
    mask,
  },
  data: () => ({
    classPadding: "my-0 py-0",
    selectedEmp: {},
    signatory: {},
    designation: null,
    formats: [],
    format: "",
    loading: false,
    //client: "128",
    basicSalary: "",
    letterContents: [],
    messageCode: null,
    employees: [],
    payLoc: [],
    payLocHeaders: [
      {
        text: "Loc Id",
        align: "left",
        //sortable: false,
        value: "locId",
      },
      {
        text: "Location Name",
        align: "left",
        //sortable: false,
        value: "locName",
      },
    ],
    panel: [0],
    dateFrom: null,
    workshift: "",
    id1: null,
    id2: null,
    from: null,
    to: null,
    breakSched: "00:00",
    cutoff: [],
    yearContractSigned: 0,
    breakDuration: "",
    breakDay: "",
    supervisor: {},
  }),
  computed: {
    ...mapState("other", ["client"]),
  },
  components: {
    EmpLookup,
    EmployeeSelection,
    PayLocSelection,
    CustomDatepicker,
    WorkShiftLookup,
  },
  methods: {
    getDesignation(empCode) {
      this.$axios
        .get(`/api/designation/empCode/${empCode}`)
        .then(({ data }) => {
          this.designation = data.desDesc;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    getContractFormat() {
      this.$axios
        .get(`${API_ENDPOINT}/contract-format`)
        .then(({ data }) => {
          // console.log(data)
          this.formats = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    exportReport() {
      this.loading = true;
      if (
        this.client == "IBC" &&
        (this.format == "EmploymentContract_2.rpt" ||
          this.format == "Project_Base" ||
          this.format == "EmploymentContract_3.rpt" ||
          this.format == "Fixed_Term" ||
          this.format == "Casual")
      ) {
        var param = {};
        var url = "";
        if (this.format == "EmploymentContract_2.rpt") {
          url = "/api/reports/ibc-prob-contract";
          param = {
            EmpCode: this.selectedEmp.code,
            Date: this.dateFrom,
            Signatory: this.signatory.code,
          };
        } else if (this.format == "Project_Base") {
          url = "/api/reports/ibc-proj-base-contract";
          param = {
            EmpCode: this.selectedEmp.code,
            From: this.from,
            To: this.to,
            Break: this.breakSched,
            Signatory: this.signatory.code,
            EmpCodes: this.employees,
          };
        } else if (this.format == "EmploymentContract_3.rpt") {
          url = "/api/reports/ibc-regular-contract";
          param = {
            EmpCode: this.selectedEmp.code,
            From: this.from,
            To: this.to,
            Break: this.breakSched,
            Signatory: this.signatory.code,
            ID1: this.id1,
            ID2: this.id2,
            EmpCodes: this.employees,
          };
        } else if (this.format == "Fixed_Term") {
          url = "/api/reports/ibc-fixed-term-contract";
          param = {
            EmpCode: this.selectedEmp.code,
            From: this.from,
            To: this.to,
            Break: this.breakSched,
            Signatory: this.signatory.code,
            ID1: this.id1,
            ID2: this.id2,
            EmpCodes: this.employees,
          };
        } else if (this.format == "Casual") {
          url = "/api/reports/ibc-casual-contract";
          param = {
            EmpCode: this.selectedEmp.code,
            From: this.from,
            To: this.to,
            Break: this.breakSched,
            Signatory: this.signatory.code,
            EmpCodes: this.employees,
          };
        }
        this.$axios
          .post(`${url}`, param)
          .then(({ data }) => {
            var nameOfTheCsv = "";
            if (this.format == "EmploymentContract_2.rpt") {
              nameOfTheCsv = "ProbationaryContract.docx";
            } else if (this.format == "Project_Base")
              nameOfTheCsv = "ProjectBasedContract.docx";
            else if (this.format == "EmploymentContract_3.rpt")
              nameOfTheCsv = "RegularContract.docx";
            else if (this.format == "Fixed_Term")
              nameOfTheCsv = "FixedTermContract.docx";
            else if (this.format == "Casual")
              nameOfTheCsv = "CasualContract.docx";
            this.$axios
              .get(`/Files/WordDocuments/IBC/${nameOfTheCsv}`, {
                responseType: "blob",
              })
              .then((response) => {
                const downloadUrl = window.URL.createObjectURL(
                  new Blob([response.data])
                );
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.setAttribute("download", nameOfTheCsv);
                document.body.appendChild(link);
                link.click();
                link.remove();
              })
              .catch((err) => console.log(err));
          })
          .catch(({ response }) => {
            this.$toast.error(response.data.message);
          })
          .finally(() => {
            this.loading = false;
          });
      } else if (
        this.client == "CCF" &&
        (this.format == "Cons_Agreement" ||
          this.format == "EmploymentContract_1.rpt" ||
          this.format == "EmploymentContract_3.rpt")
      ) {
        var param = {};
        var url = "";
        if (this.format == "Cons_Agreement") {
          url = "/api/reports/consultant-agreement";
          let cutoffDetails = "";
          if (this.cutoff.length > 1) {
            cutoffDetails = "15th and 30th";
          } else {
            if (this.cutoff.length > 0) cutoffDetails = `${this.cutoff[0]}th`;
          }
          param = {
            EmpCode: this.selectedEmp.code,
            Cutoff: cutoffDetails,
            YearContractSigned: this.yearContractSigned,
          };
        }

        if (this.format == "EmploymentContract_1.rpt") {
          url = "/api/reports/ccf-contractual-emp";
          let cutoffDetails = "";
          if (this.cutoff.length > 1) {
            cutoffDetails = "15th and 30th";
          } else {
            if (this.cutoff.length > 0) cutoffDetails = `${this.cutoff[0]}th`;
          }
          param = {
            EmpCode: this.selectedEmp.code,
            Cutoff: cutoffDetails,
            YearContractSigned: this.yearContractSigned,
            BreakDuration: this.breakDuration,
            BreakDay: this.breakDay,
            Supervisor: this.supervisor.code,
          };
        }

        if (this.format == "EmploymentContract_3.rpt") {
          url = "/api/reports/ccf-regular-contract-emp";
          let cutoffDetails = "";
          // if (this.cutoff.length == 3) {
          //   cutoffDetails = "15th and 30th of the month OR 20th of the month";
          // } else if (this.cutoff.length == 2) {
          //   let d
          //   if(this.cutoff.includes('15')) {
          //     d = " OR 20th of the month"
          //   }
          //   cutoffDetails = "15th and 30th of the month";
          // } else {
          //   if (this.cutoff.length == 1) cutoffDetails = `15th of the month`;
          // }
          param = {
            EmpCode: this.selectedEmp.code,
            //Cutoff: cutoffDetails,
            YearContractSigned: this.yearContractSigned,
            Supervisor: this.supervisor.code,
          };
        }

        this.$axios
          .post(`${url}`, param)
          .then(({ data }) => {
            var nameOfTheCsv = "";
            if (this.format == "Cons_Agreement") {
              nameOfTheCsv = "ConsultantAgreement.docx";
            } else if (this.format == "EmploymentContract_1.rpt") {
              nameOfTheCsv = "ContractualEmploymentContract.docx";
            } else if (this.format == "EmploymentContract_3.rpt") {
              nameOfTheCsv = "RegularEmploymentContract.docx";
            }
            this.$axios
              .get(`/Files/WordDocuments/CCF/${nameOfTheCsv}`, {
                responseType: "blob",
              })
              .then((response) => {
                const downloadUrl = window.URL.createObjectURL(
                  new Blob([response.data])
                );
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.setAttribute("download", nameOfTheCsv);
                document.body.appendChild(link);
                link.click();
                link.remove();
              })
              .catch((err) => console.log(err));
          })
          .catch(({ response }) => {
            this.$toast.error(response.data.message);
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        var data = {
          EmpCode: this.selectedEmp.code,
          SelectedRpt: this.format,
          BasicSalary: this.basicSalary,
          Signatory: this.signatory.desc,
          Designation: this.designation,
        };

        var url = `${API_ENDPOINT}/contract?messageCode=${this.messageCode}`;

        if (this.employees.length > 0) {
          data = {
            EmpCodes: this.employees,
            SelectedRpt: this.format,
            BasicSalary: this.basicSalary,
            Signatory: this.signatory.desc,
            Designation: this.designation,
          };

          url = `${API_ENDPOINT}/contract-multiple?messageCode=${this.messageCode}`;
        }

        this.$axios
          .post(`${url}`, data)
          .then(({ data }) => {
            var subPath = process.env.VUE_APP_PATH;

            window.open(
              `${subPath.slice(0, -1)}/report-viewer?reportCode=${
                data.reportCode
              }&dbName=${data.dbName}&key=${data.key}&companyKey=${
                data.companyKey
              }&reportUrl=${data.url}&client=${data.client}&logoAlign=${
                data.logoAlign
              }&logoWidth=${data.logoWidth}&rpt=${data.rpt}`
            );
          })
          .catch(({ response }) => {
            this.$toast.error(response.data.message);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    getLetterContents() {
      this.$axios
        .get(`${API_ENDPOINT_LETTER}`)
        .then(({ data }) => {
          this.letterContents = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
  },
  created() {
    //this.getClient();

    this.getContractFormat();
    this.getLetterContents();
  },
  watch: {
    signatory(val) {
      if (!isNullOrUndefined(val.code)) {
        this.getDesignation(val.code);
      } else {
        this.designation = null;
      }
    },
  },
};
</script>
